import React from "react";

import { Card } from "affinityUI/elements/card";
import { Layout } from "affinityUI/structures/layout";

import { IssueDeviceView } from "../../../views/patientDetails/device/issueDevice";

export const DeviceInfoPage: React.FC = () => {
  return (
    <Layout title="Device information" showBackBtn backLink="..">
      <Card>
        <h2>Entia</h2>
        <p>
          At the heart of Liberty lies our blood analyser that allows patients to perform simple blood tests from home.
          This cloud-connected analyser already offers insights into blood counts which can be reviewed by the health
          care professional.
        </p>
        <p>Assigning a device will trigger the below journey where a device will be delivered to a patient.</p>
        <IssueDeviceView actions={<></>} />
      </Card>
    </Layout>
  );
};
